import React from "react";
import Layout from "./utilities/Layout";
import { withRouter } from "react-router-dom";
import OptionsTabs from "./OptionsTabs";

class Options extends React.Component {
  render() {
    return (
      <Layout
        params={this.props.match.params}
        title="Options"
        history={this.props.history}
      >
        <OptionsTabs history={this.props.history} />
      </Layout>
    );
  }
}
export default withRouter(Options);



// WEBPACK FOOTER //
// ./src/components/Options.js